/* This example requires  Tailwind CSS v2.0+ */
import React, { useState } from "react";
import { Link } from "gatsby";
import AbtLogo from "~/images/Art_of_bicycle_trips_Final_logo2.png";
import { Fragment } from "react";
import { Popover, Transition } from "@headlessui/react";
import { MenuIcon, PhoneIcon, PlayIcon, XIcon } from "@heroicons/react/outline";
import { ChevronDownIcon, ChatIcon } from "@heroicons/react/solid";
//import Location from "~/components/location";

const activities = [
	{
		name: "Cycling",
		description:
			"Join our top cycling guides on an exhilarating ride through immaculate backroads, with constant support from our nearby van. ",
		to: "/activities/cycling",
		//icon: ChartBarIcon,
	},
	{
		name: "Multisport",
		description:
			"Designed for those who want to fully embrace a region's wonders by combining cycling experiences with an array of other activities.",
		to: "/activities/multisport",
		//icon: ChartBarIcon,
	},
	// {
	// 	name: "Hiking",
	// 	description:
	// 		"allows you to immerse in breathtaking landscapes, whether it's scaling majestic mountains, traversing dense forests, or strolling along picturesque trails.",
	// 	to: "/activities/hiking",
	// 	icon: ChartBarIcon,
	// },
	// {
	// 	name: "Active Cultural",
	// 	description:
	// 		"Immerse yourselves into a region by balancing culture with local activities. Here, you get to enjoy in-destination activities; biking, hiking, walking, kayaking, yoga, birding, and About while exploring local culture and history.",
	// 	to: "/activities/active-cultural",
	// 	icon: CursorClickIcon,
	// },
];

// const destinations = [
// 	{
// 		name: "India",
// 		to: "/destinations/india/",
// 	},
// 	{
// 		name: "Vietnam",
// 		to: "/destinations/vietnam/",
// 	},
// 	{
// 		name: "Cambodia",
// 		to: "/destinations/cambodia/",
// 	},
// 	{
// 		name: "Thailand",
// 		to: "/destinations/thailand/",
// 	},
// 	{
// 		name: "Laos",
// 		to: "/destinations/laos/",
// 	},
// 	{
// 		name: "Sri Lanka",
// 		to: "/destinations/sri-lanka/",
// 	},
// 	{
// 		name: "Bhutan",
// 		to: "/destinations/bhutan/",
// 	},
// ];
const asia = [
	// {
	// 	name: "All Asia",
	// 	to: "/destinations/asia-bike-tours",
	// },
	{
		name: "Bhutan",
		to: "/destinations/bhutan-cycling-tours/",
	},
	{
		name: "Cambodia",
		to: "/destinations/cambodia-bike-tours/",
	},
	{
		name: "India",
		to: "/destinations/india-bicycle-tours/",
	},

	{
		name: "Japan",
		to: "/destinations/japan-bike-tours/",
	},
	{
		name: "Jordan",
		to: "/destinations/jordan-bike-tours/",
	},
	{
		name: "Laos",
		to: "/destinations/laos-bike-tours/",
	},
	{
		name: "Mongolia",
		to: "/destinations/mongolia-bike-tours/",
	},
	{
		name: "Nepal",
		to: "/destinations/nepal-bike-tours/",
	},
	{
		name: "Philippines",
		to: "/destinations/philippines-bike-tours/",
	},
	{
		name: "Sri Lanka",
		to: "/destinations/sri-lanka-cycling-tours/",
	},
	{
		name: "Taiwan",
		to: "/destinations/taiwan-bike-tours/",
	},
	{
		name: "Thailand",
		to: "/destinations/thailand-bike-tours/",
	},
	{
		name: "Vietnam",
		to: "/destinations/vietnam-bike-tours/",
	},
];
const southam = [
	{
		name: "Chile",
		to: "/destinations/chile-bike-tours/",
	},
];
const africa = [
	{
		name: "Morocco",
		to: "/destinations/morocco-bike-tours/",
	},
];

const europe = [
	{
		name: "Albania",
		to: "/destinations/albania-bike-tours/",
	},
	{
		name: "Austria",
		to: "/destinations/austria-bike-tours/",
	},
	{
		name: "Croatia",
		to: "/destinations/croatia-bike-tours/",
	},
	{
		name: "Czech Republic",
		to: "/destinations/czech-republic-bike-tours/",
	},
	{
		name: "France",
		to: "/destinations/france-bike-tours/",
	},
	{
		name: "Greece",
		to: "/destinations/greece-bike-tours/",
	},
	{
		name: "Ireland",
		to: "/destinations/ireland-bike-tours/",
	},
	{
		name: "Italy",
		to: "/destinations/italy-bike-tours/",
	},
	{
		name: "Hungary",
		to: "/destinations/hungary-bike-tours/",
	},
	{
		name: "Montenegro",
		to: "/destinations/montenegro-bike-tours/",
	},
	{
		name: "Norway",
		to: "/destinations/norway-bike-tours/",
	},
	{
		name: "Poland",
		to: "/destinations/poland-bike-tours/",
	},
];

const europe2 = [
	{
		name: "Portugal",
		to: "/destinations/portugal-bike-tours/",
	},
	{
		name: "Romania",
		to: "/destinations/romania-bike-tours/",
	},
	{
		name: "Slovakia",
		to: "/destinations/slovakia-bike-tours/",
	},
	{
		name: "Slovenia",
		to: "/destinations/slovenia-bike-tours/",
	},
	{
		name: "Spain",
		to: "/destinations/spain-bike-tours/",
	},
];

const india = [
	{
		name: "All India",
		to: "/destinations/india-bicycle-tours//",
	},
	{
		name: "Rajasthan",
		to: "/destinations/rajasthan-cycling-tours/",
	},
	{
		name: "Kerala & South India",
		to: "/destinations/kerala-cycling-tours/",
	},
	{
		name: "Goa",
		to: "/destinations/goa-cycling-tours/",
	},
	{
		name: "Himalayas",
		to: "/destinations/cycling-tours-himalayas/",
	},
	{
		name: "Northeast",
		to: "/destinations/northeast-india/",
	},
];
// const day = [
// 	{
// 		name: "Bangalore",
// 		to: "/destinations/bangalore/",
// 	},
// {
// 	name: "Kochi",
// 	to: "/destinations/kochi",
// },
// {
// 	name: "Udaipur",
// 	to: "/destinations/udaipur",
// },
//];
const specialities = [
	{
		name: "Bike & Boat Tours",
		//description: "Offers an independent and flexible way",
		to: "/specialities/bike-and-boat-tours/",
		//icon: ChartBarIcon,
	},
	{
		name: "Self-guided Bike Tours",
		//description: "Offers an independent and flexible way",
		to: "/specialities/self-guided-bike-tours/",
		//icon: ChartBarIcon,
	},
	{
		name: "Luxury Bike Tours",
		//description:"Includes some of the most prestigious hotels that have been acclaimed as 'the best'",
		to: "/specialities/luxury-bike-tours/",
		//icon: ChartBarIcon,
	},
	{
		name: "E-Bike Tours for Seniors",
		//description:"Allows you to ride together and farther with a tailwind style support.",
		to: "/specialities/e-bike-tours-for-seniors/",
	},
	{
		name: "Road Bike Tours",
		//description:"Designed for those who love to take their road bikes out in nature and do century rides",
		to: "/specialities/road-bike-tours/",
		//icon: ChartBarIcon,
	},
	{
		name: "Gravel Bike Tours",
		//description:"Designed for those who love to take their road bikes out in nature and do century rides",
		to: "/specialities/gravel-bike-tours/",
		//icon: ChartBarIcon,
	},

	{
		name: "Multi-sport Adventures",
		//description:"Enjoy biking paired with hiking, kayaking, yoga, whitewater rafting, bird watching",
		to: "/specialities/multi-sport-tours/",
		//icon: ChartBarIcon,
	},
	{
		name: "Family Bike Tours",
		//description:"Offers perfect bonding opportunity in the outdoors with your teens and kids",
		to: "/specialities/family/",
		//icon: ChartBarIcon,
	},

	// {
	// 	name: "Day Experiences",
	// 	description:
	// 		"Awesome activities with a variety of local experiences. Awarded as top things to do.",
	// 	to: "/specialities/day",

	// },
];

// Define UTM parameters
const contactUsUTM = new URLSearchParams({
	utm_source: "navbar",
	utm_medium: "cta-button",
	utm_campaign: "contact-us-nav",
}).toString();

const contactUsWithUTM = `/contact-us?${contactUsUTM}`;

const designTripUTM = new URLSearchParams({
	utm_source: "navbar",
	utm_medium: "cta-button",
	utm_campaign: "design-my-trip-nav",
}).toString();

const designTripWithUTM = `/design-trip?${designTripUTM}`;

const callsToAction = [
	{ name: "Watch Demo", to: "#", icon: PlayIcon },
	{ name: "Contact Sales", to: "#", icon: PhoneIcon },
];
const resources = [
	{
		name: "Our Company",
		to: "/about-us/our-company/",
	},
];
const recentPosts = [
	{ id: 1, name: "Boost your conversion rate", to: "#" },
	{
		id: 2,
		name: "How to use search engine optimization to drive traffic to your site",
		to: "#",
	},
	{ id: 3, name: "Improve your customer experience", to: "#" },
];

function classNames(...classes) {
	return classes.filter(Boolean).join(" ");
}

export default function Navbar() {
	return (
		<Popover className="relative bg-white">
			{({ open }) => (
				<>
					<div className="max-w-7xl mx-auto">
						<div className="flex justify-between items-center py-2 lg:justify-start lg:space-x-10">
							<div className="flex justify-start my-4 lg:w-0 lg:flex-1">
								<Link to="/">
									<span className="sr-only">Workflow</span>
									<img
										className="h-12 w-auto sm:h-14"
										src={AbtLogo}
										alt="Art of Bicycle Trips logo"
									/>
								</Link>
							</div>
							<div className="hidden md:flex items-center justify-end md:flex-1 md:w-0 md:mr-6 ">
								<a
									href="/design-trip/"
									className="whitespace-nowrap tracking-wide uppercase font-semibold text-primary px-5 py-2 border border-primary rounded-full shadow-sm"
								>
									Design Private Trip
								</a>
								<a
									href="/contact-us/"
									className="ml-4 uppercase tracking-wide whitespace-nowrap inline-flex items-center justify-center px-7 py-2 border border-transparent rounded-full shadow-sm font-semibold text-white bg-primary hover:bg-primary"
								>
									Contact Us
								</a>
							</div>
							<div className="-mr-2 -my-2 lg:hidden">
								<Popover.Button className="bg-white rounded-md p-2 inline-flex items-center justify-center text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-primary">
									<span className="sr-only">Open menu</span>
									<MenuIcon className="h-6 w-6" aria-hidden="true" />
								</Popover.Button>
							</div>
						</div>
						<Popover.Group as="nav" className="hidden lg:flex lg:pb-10 space-x-8">
							<Popover className="relative">
								{({ open }) => (
									<>
										<Popover.Button
											className={classNames(
												open ? "text-gray-900" : "text-gray-600",
												"group bg-white rounded-md inline-flex items-center text-base font-medium hover:text-gray-900 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary"
											)}
										>
											<span>Destinations</span>
											<ChevronDownIcon
												className={classNames(
													open ? "text-gray-600" : "text-gray-400",
													"ml-2 h-5 w-5 group-hover:text-gray-500"
												)}
												aria-hidden="true"
											/>
										</Popover.Button>

										<Transition
											show={open}
											as={Fragment}
											enter="transition ease-out duration-200"
											enterFrom="opacity-0 translate-y-1"
											enterTo="opacity-100 translate-y-0"
											leave="transition ease-in duration-150"
											leaveFrom="opacity-100 translate-y-0"
											leaveTo="opacity-0 translate-y-1"
										>
											<Popover.Panel
												static
												className="absolute z-20 -ml-4 mt-3 transform px-2 w-screen max-w-3xl sm:px-0 lg:ml-0 lg:left-1/2 lg:-translate-x-1/5"
											>
												<div className="rounded-lg shadow-lg ring-1 ring-black ring-opacity-5 overflow-hidden">
													<div className="relative grid grid-cols-5 gap-6 bg-white px-5 py-6 sm:gap-8 sm:p-8">
														{/* <div className="ml-4">
															<p className="mb-4 text-base font-medium text-primary">INDIA</p>
															{india.map((item) => (
																<Link
																	key={item.name}
																	to={item.to}
																	className="-m-3 p-3 flex items-start rounded-lg hover:bg-secondary"
																>
																	<div className="">
																		<p className="text-sm text-gray-600 hover:text-gray-900">
																			{item.name}
																		</p>
																	</div>
																</Link>
															))}
															<div className="mt-10">
																<p className="mb-4 text-base font-medium text-primary">
																	DAY TRIPS
																</p>
																{day.map((item) => (
																	<Link
																		key={item.name}
																		to={item.to}
																		className="-m-3 p-3 flex items-start rounded-lg hover:bg-secondary"
																	>
																		<div className="">
																			<p className="text-sm text-gray-600 hover:text-gray-900">
																				{item.name}
																			</p>
																		</div>
																	</Link>
																))}
															</div>
														</div> */}
														<div className="ml-4">
															<p className="mb-4">
																<a
																	href="/destinations/asia-bike-tours"
																	className="text-base font-medium text-primary"
																>
																	ASIA
																</a>
															</p>
															{asia.map((item) => (
																<a
																	key={item.name}
																	href={`${item.to}`}
																	className="-m-3 p-3 flex items-start rounded-lg hover:bg-secondary"
																>
																	<div className="">
																		<p className="text-sm text-gray-600 hover:text-gray-900">
																			{item.name}
																		</p>
																		{/* <p className="mt-1 text-sm text-gray-500">
																			{item.description}
																		</p> */}
																	</div>
																</a>
															))}
														</div>
														<div className="ml-4">
															<p className="mb-4">
																<a
																	href="/destinations/europe-bike-tours"
																	className="text-base font-medium text-primary"
																>
																	EUROPE
																</a>
															</p>
															{europe.map((item) => (
																<a
																	key={item.name}
																	href={`${item.to}`}
																	className="-m-3 p-3 flex items-start rounded-lg hover:bg-secondary"
																>
																	<div className="">
																		<p className="text-sm text-gray-600 hover:text-gray-900">
																			{item.name}
																		</p>
																		{/* <p className="mt-1 text-sm text-gray-500">
																			{item.description}
																		</p> */}
																	</div>
																</a>
															))}
														</div>
														<div className="ml-4">
															<p className="mb-4">
																<a
																	href="/destinations/europe-bike-tours"
																	className="text-base font-medium text-primary"
																>
																	EUROPE
																</a>
															</p>
															{europe2.map((item) => (
																<a
																	key={item.name}
																	href={`${item.to}`}
																	className="-m-3 p-3 flex items-start rounded-lg hover:bg-secondary"
																>
																	<div className="">
																		<p className="text-sm text-gray-600 hover:text-gray-900">
																			{item.name}
																		</p>
																		{/* <p className="mt-1 text-sm text-gray-500">
																			{item.description}
																		</p> */}
																	</div>
																</a>
															))}
														</div>
														<div className="ml-4">
															<p className="mb-4">
																<a
																	href="/destinations/africa-bike-tours"
																	className="text-base font-medium text-primary"
																>
																	AFRICA
																</a>
															</p>
															{africa.map((item) => (
																<a
																	key={item.name}
																	href={`${item.to}`}
																	className="-m-3 p-3 flex items-start rounded-lg hover:bg-secondary"
																>
																	<div className="">
																		<p className="text-sm text-gray-600 hover:text-gray-900">
																			{item.name}
																		</p>
																		{/* <p className="mt-1 text-sm text-gray-500">
																			{item.description}
																		</p> */}
																	</div>
																</a>
															))}
														</div>

														<div className="ml-4">
															<p className="mb-4">
																<a
																	href="/destinations/south-america-bike-tours"
																	className="text-base font-medium text-primary"
																>
																	SOUTH AMERICA
																</a>
															</p>
															{southam.map((item) => (
																<a
																	key={item.name}
																	href={`${item.to}`}
																	className="-m-3 p-3 flex items-start rounded-lg hover:bg-secondary"
																>
																	<div className="">
																		<p className="text-sm text-gray-600 hover:text-gray-900">
																			{item.name}
																		</p>
																		{/* <p className="mt-1 text-sm text-gray-500">
																			{item.description}
																		</p> */}
																	</div>
																</a>
															))}
														</div>

														{/* <div className="ml-4">
															<p className="mb-4 text-base font-medium text-primary">
																DAY TRIPS
															</p>
															{day.map((item) => (
																<Link
																	key={item.name}
																	to={item.to}
																	className="-m-3 p-3 flex items-start rounded-lg hover:bg-secondary"
																>
																	<div className="">
																		<p className="text-sm text-gray-600 hover:text-gray-900">
																			{item.name}
																		</p> */}
														{/* <p className="mt-1 text-sm text-gray-500">
																			{item.description}
																		</p> */}
														{/* </div>
																</Link>
															))}
														</div> */}
													</div>
													{/* <div className="px-5 py-5 bg-gray-50 space-y-6 sm:flex sm:space-y-0 sm:space-x-10 sm:px-8">
															{callsToAction.map((item) => (
																<div key={item.name} className="flow-root">
																	<Link
																		to={item.to}
																		className="-m-3 p-3 flex items-center rounded-md text-base font-medium text-gray-900 hover:bg-gray-100"
																	>
																		<span className="ml-3">{item.name}</span>
																	</Link>
																</div>
															))}
														</div> */}
												</div>
											</Popover.Panel>
										</Transition>
									</>
								)}
							</Popover>

							{/* Activities */}

							{/* <Popover className="relative">
								{({ open }) => (
									<>
										<Popover.Button
											className={classNames(
												open ? "text-gray-900" : "text-gray-600",
												"group bg-white rounded-md inline-flex items-center text-base font-medium hover:text-gray-900 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary"
											)}
										>
											<span>Activities</span>
											<ChevronDownIcon
												className={classNames(
													open ? "text-gray-600" : "text-gray-400",
													"ml-2 h-5 w-5 group-hover:text-gray-500"
												)}
												aria-hidden="true"
											/>
										</Popover.Button>

										<Transition
											show={open}
											as={Fragment}
											enter="transition ease-out duration-200"
											enterFrom="opacity-0 translate-y-1"
											enterTo="opacity-100 translate-y-0"
											leave="transition ease-in duration-150"
											leaveFrom="opacity-100 translate-y-0"
											leaveTo="opacity-0 translate-y-1"
										>
											<Popover.Panel
												static
												className="absolute z-10 -ml-4 mt-3 transform px-2 w-screen max-w-lg sm:px-0 lg:ml-0 lg:left-1/2 lg:-translate-x-1/5"
											>
												<div className="rounded-lg shadow-lg ring-1 ring-black ring-opacity-5 overflow-hidden">
													<div className="relative grid gap-6 bg-white px-5 py-6 sm:gap-8 sm:p-8">
														{activities.map((item) => (
															<a
																key={item.name}
																href={`${item.to}?utm_source=navbar&utm_medium=nav-link&utm_campaign=${item.name}`}
																className="-m-3 p-3 flex items-start rounded-lg hover:bg-secondary"
															>
																<div className="ml-4">
																	<p className="text-base font-medium text-primary">
																		{item.name}
																	</p>
																	<p className="mt-1 text-sm text-gray-600">
																		{item.description}
																	</p>
																</div>
															</a>
														))}
													</div>
												</div>
											</Popover.Panel>
										</Transition>
									</>
								)}
							</Popover> */}
							{/* Collections */}
							<Popover className="relative">
								{({ open }) => (
									<>
										<Popover.Button
											className={classNames(
												open ? "text-gray-900" : "text-gray-600",
												"group bg-white rounded-md inline-flex items-center text-base font-medium hover:text-gray-900 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary"
											)}
										>
											<span>Collections</span>
											<ChevronDownIcon
												className={classNames(
													open ? "text-gray-600" : "text-gray-400",
													"ml-2 h-5 w-5 group-hover:text-gray-500"
												)}
												aria-hidden="true"
											/>
										</Popover.Button>

										<Transition
											show={open}
											as={Fragment}
											enter="transition ease-out duration-200"
											enterFrom="opacity-0 translate-y-1"
											enterTo="opacity-100 translate-y-0"
											leave="transition ease-in duration-150"
											leaveFrom="opacity-100 translate-y-0"
											leaveTo="opacity-0 translate-y-1"
										>
											<Popover.Panel
												static
												className="absolute z-20 -ml-4 mt-3 transform px-2 w-screen max-w-xs sm:px-0 lg:ml-0 lg:left-1/2 lg:-translate-x-1/5"
											>
												<div className="rounded-lg shadow-lg ring-1 ring-black ring-opacity-5 overflow-hidden">
													<div className="relative grid gap-6 bg-white px-5 py-6 sm:gap-6 sm:p-8">
														{specialities.map((item) => (
															<a
																key={item.name}
																href={`${item.to}`}
																className="-m-3 p-3 flex items-start rounded-lg hover:bg-secondary"
															>
																<div className="ml-4">
																	<p className="text-sm text-gray-600 hover:text-gray-900">
																		{item.name}
																	</p>
																	{/* <p className="mt-1 text-sm text-gray-600">
																		{item.description}
																	</p> */}
																</div>
															</a>
														))}
													</div>
													{/* <div className="px-5 py-5 bg-gray-50 space-y-6 sm:flex sm:space-y-0 sm:space-x-10 sm:px-8">
															{callsToAction.map((item) => (
																<div key={item.name} className="flow-root">
																	<Link
																		to={item.to}
																		className="-m-3 p-3 flex items-center rounded-md text-base font-medium text-gray-900 hover:bg-gray-100"
																	>
																		<span className="ml-3">{item.name}</span>
																	</Link>
																</div>
															))}
														</div> */}
												</div>
											</Popover.Panel>
										</Transition>
									</>
								)}
							</Popover>
							{/* <Popover className="relative">
									{({ open }) => (
										<>
											<Popover.Button
												className={classNames(
													open ? "text-gray-900" : "text-gray-600",
													"group bg-white rounded-md inline-flex items-center text-base font-medium hover:text-gray-900 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary"
												)}
											>
												<span>Activities</span>
												<ChevronDownIcon
													className={classNames(
														open ? "text-gray-600" : "text-gray-400",
														"ml-2 h-5 w-5 group-hover:text-gray-500"
													)}
													aria-hidden="true"
												/>
											</Popover.Button>

											<Transition
												show={open}
												as={Fragment}
												enter="transition ease-out duration-200"
												enterFrom="opacity-0 translate-y-1"
												enterTo="opacity-100 translate-y-0"
												leave="transition ease-in duration-150"
												leaveFrom="opacity-100 translate-y-0"
												leaveTo="opacity-0 translate-y-1"
											>
												<Popover.Panel
													static
													className="absolute z-10 -ml-4 mt-3 transform px-2 w-screen max-w-md sm:px-0 lg:ml-0 lg:left-1/2 lg:-translate-x-1/2"
												>
													<div className="rounded-lg shadow-lg ring-1 ring-black ring-opacity-5 overflow-hidden">
														<div className="relative grid gap-6 bg-white px-5 py-6 sm:gap-8 sm:p-8">
															{activities.map((item) => (
																<Link
																	key={item.name}
																	to={item.to}
																	className="-m-3 p-3 flex items-start rounded-lg hover:bg-gray-50"
																>
																	<item.icon
																		className="flex-shrink-0 h-6 w-6 text-primary"
																		aria-hidden="true"
																	/>
																	<div className="ml-4">
																		<p className="text-base font-medium text-gray-900">
																			{item.name}
																		</p>
																		<p className="mt-1 text-sm text-gray-500">
																			{item.description}
																		</p>
																	</div>
																</Link>
															))}
														</div>
														<div className="px-5 py-5 bg-gray-50 space-y-6 sm:flex sm:space-y-0 sm:space-x-10 sm:px-8">
															{callsToAction.map((item) => (
																<div key={item.name} className="flow-root">
																	<Link
																		to={item.to}
																		className="-m-3 p-3 flex items-center rounded-md text-base font-medium text-gray-900 hover:bg-gray-100"
																	>
																		<item.icon
																			className="flex-shrink-0 h-6 w-6 text-gray-400"
																			aria-hidden="true"
																		/>
																		<span className="ml-3">{item.name}</span>
																	</Link>
																</div>
															))}
														</div>
													</div>
												</Popover.Panel>
											</Transition>
										</>
									)}
								</Popover> */}

							{/* <Link
									to="/reviews"
									className="text-base font-medium text-gray-600 hover:text-gray-900"
								>
									Reviews
								</Link>
								<Link
									to="/blog"
									className="text-base font-medium text-gray-600 hover:text-gray-900"
								>
									Blog
								</Link> */}
							<Link
								to="/guaranteed-bike-tours"
								className="text-base font-medium text-gray-600 hover:text-gray-900"
							>
								Guaranteed Trips
							</Link>
							<Link
								to="/about-us/reviews"
								className="text-base font-medium text-gray-600 hover:text-gray-900"
							>
								Reviews
							</Link>
							{/* <Link
								to="/members-only"
								className="text-base font-medium text-gray-600 hover:text-gray-900"
							>
								Membership
							</Link> */}
							{/* <Link
								to="/private"
								className="text-base font-medium text-gray-600 hover:text-gray-900"
							>
								Private Trips
							</Link> */}
							{/* <Link
								to="/offers"
								className="text-base font-medium text-gray-600 hover:text-gray-900"
							>
								Offers
							</Link> */}
							<Link
								to="/what-to-expect"
								className="text-base font-medium text-gray-600 hover:text-gray-900"
							>
								What to Expect
							</Link>
							{/* <a
								href="https://www.trustpilot.com/review/artofbicycletrips.com"
								target="_blank"
								className="text-base font-medium text-gray-600 hover:text-gray-900"
							>
								Reviews
							</a> */}
							{/* <Link
								to="/blog"
								className="text-base font-medium text-gray-600 hover:text-gray-900"
							>
								Blog
							</Link> */}

							<Link
								to="/about-us/our-company"
								className="text-base font-medium text-gray-600 hover:text-gray-900"
							>
								About Us
							</Link>

							{/* <a
								id="send_message"
								className="text-base font-medium text-gray-600 hover:text-gray-900"
								href="mailto:contact@artofbicycletrips.com"
							>
								Contact Us
							</a> */}

							{/* <Popover className="relative">
									{({ open }) => (
										<>
											<Popover.Button
												className={classNames(
													open ? "text-gray-900" : "text-gray-600",
													"group bg-white rounded-md inline-flex items-center text-base font-medium hover:text-gray-900 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary"
												)}
											>
												<span>About</span>
												<ChevronDownIcon
													className={classNames(
														open ? "text-gray-600" : "text-gray-400",
														"ml-2 h-5 w-5 group-hover:text-gray-500"
													)}
													aria-hidden="true"
												/>
											</Popover.Button>

											<Transition
												show={open}
												as={Fragment}
												enter="transition ease-out duration-200"
												enterFrom="opacity-0 translate-y-1"
												enterTo="opacity-100 translate-y-0"
												leave="transition ease-in duration-150"
												leaveFrom="opacity-100 translate-y-0"
												leaveTo="opacity-0 translate-y-1"
											>
												<Popover.Panel
													static
													className="absolute z-10 left-1/2 transform -translate-x-1/2 mt-3 px-2 w-screen max-w-xs sm:px-0"
												>
													<div className="rounded-lg shadow-lg ring-1 ring-black ring-opacity-5 overflow-hidden">
														<div className="relative grid gap-6 bg-white px-5 py-6 sm:gap-8 sm:p-8">
															{resources.map((item) => (
																<Link
																	key={item.name}
																	to={item.to}
																	className="-m-3 p-3 flex items-start rounded-lg hover:bg-secondary"
																>
																	
																	<div className="ml-4">
																		<p className="text-sm text-gray-600 hover:text-gray-900">
																			{item.name}
																		</p>
																		
																	</div>
																</Link>
															))}
														</div>
														
													</div>
												</Popover.Panel>
											</Transition>
										</>
									)}
								</Popover> */}
						</Popover.Group>
					</div>

					<Transition
						show={open}
						as={Fragment}
						enter="duration-200 ease-out"
						enterFrom="opacity-0 scale-95"
						enterTo="opacity-100 scale-100"
						leave="duration-100 ease-in"
						leaveFrom="opacity-100 scale-100"
						leaveTo="opacity-0 scale-95"
					>
						<Popover.Panel
							focus
							static
							className="absolute z-30 top-0 inset-x-0 p-2 transition transform origin-top-right lg:hidden"
						>
							<div className="rounded-lg shadow-lg ring-1 ring-black ring-opacity-5 bg-white divide-y-2 divide-gray-50">
								<div className="pt-5 pb-6 px-5">
									<div className="flex items-center justify-between">
										<div>
											{/* <img
												className="h-8 w-auto"
												src="https://tailwindui.com/img/logos/workflow-mark-indigo-600.svg"
												alt="Workflow"
											/> */}
										</div>
										<div className="-mr-2">
											<Popover.Button className="bg-white rounded-md p-2 inline-flex items-center justify-center text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-primary">
												<span className="sr-only">Close menu</span>
												<XIcon className="h-6 w-6" aria-hidden="true" />
											</Popover.Button>
										</div>
									</div>

									{/* <div className="text-right">
										<Location />
									</div> */}
									<div>
										<Link
											to="/contact-us"
											className="w-full flex items-center justify-center mb-4 px-4 py-2 border border-transparent rounded-md shadow-sm text-base font-medium text-white bg-primary hover:bg-primary"
										>
											Contact Us
										</Link>
										<Link
											to="/design-trip"
											className="w-full flex items-center justify-center px-4 py-2 border border-primary rounded-md shadow-sm text-base font-medium text-primary"
										>
											Design Private Trip
										</Link>
									</div>

									<div className="mt-6">
										<nav className="grid grid-cols-2 gap-y-8 gap-x-12">
											<div className="">
												<p className="mb-4">
													<a
														href="/destinations/asia-bike-tours"
														className="text-base font-medium text-primary"
													>
														ASIA
													</a>
												</p>
												{asia.map((item) => (
													<a
														key={item.name}
														href={`${item.to}`}
														className="-m-3 p-3 flex items-start rounded-md hover:bg-secondary"
													>
														<div className="">
															<p className="text-sm font-medium">{item.name}</p>
															{/* <p className="mt-1 text-sm text-gray-500">
																			{item.description}
																		</p> */}
														</div>
													</a>
												))}
											</div>
											<div className="">
												<p className="mb-4">
													<a
														href="/destinations/europe-bike-tours"
														className="text-base font-medium text-primary"
													>
														EUROPE
													</a>
												</p>
												{europe.map((item) => (
													<a
														key={item.name}
														href={`${item.to}`}
														className="-m-3 p-3 flex items-start rounded-md hover:bg-secondary"
													>
														<div className="">
															<p className="text-sm font-medium">{item.name}</p>
															{/* <p className="mt-1 text-sm text-gray-500">
																			{item.description}
																		</p> */}
														</div>
													</a>
												))}
												{europe2.map((item) => (
													<a
														key={item.name}
														href={`${item.to}`}
														className="-m-3 p-3 flex items-start rounded-md hover:bg-secondary"
													>
														<div className="">
															<p className="text-sm font-medium">{item.name}</p>
															{/* <p className="mt-1 text-sm text-gray-500">
																			{item.description}
																		</p> */}
														</div>
													</a>
												))}
											</div>
											<div className="">
												<p className="mb-4">
													<a
														href="/destinations/africa-bike-tours"
														className="text-base font-medium text-primary"
													>
														AFRICA
													</a>
												</p>
												{africa.map((item) => (
													<a
														key={item.name}
														href={`${item.to}`}
														className="-m-3 p-3 flex items-start rounded-md hover:bg-secondary"
													>
														<div className="">
															<p className="text-sm font-medium">{item.name}</p>
															{/* <p className="mt-1 text-sm text-gray-500">
																			{item.description}
																		</p> */}
														</div>
													</a>
												))}
											</div>
											<div className="">
												<p className="mb-4">
													<a
														href="/destinations/south-america-bike-tours"
														className="text-base font-medium text-primary"
													>
														SOUTH AMERICA
													</a>
												</p>
												{southam.map((item) => (
													<a
														key={item.name}
														href={`${item.to}`}
														className="-m-3 p-3 flex items-start rounded-md hover:bg-secondary"
													>
														<div className="">
															<p className="text-sm font-medium">{item.name}</p>
															{/* <p className="mt-1 text-sm text-gray-500">
																			{item.description}
																		</p> */}
														</div>
													</a>
												))}
											</div>
										</nav>
									</div>
								</div>
								{/* <div className="py-6 px-5 space-y-6">
									<p className="mb-4 text-base font-medium uppercase text-primary">
										Collections
									</p>
									<div className="grid grid-cols-2 gap-y-4 gap-x-8">
										{specialities.map((item) => (
											<Link
												key={item.name}
												to={item.to}
												className="text-sm font-medium text-gray-900 hover:text-gray-700"
											>
												{item.name}
											</Link>
										))}
									</div>
								</div> */}
								<div className="py-6 px-5 space-y-6">
									<div className="grid grid-cols-2 gap-y-4 gap-x-8">
										{/* <Link
											to="/reviews"
											className="text-sm font-medium text-gray-900 hover:text-gray-700"
										>
											Reviews
										</Link>

										<Link
											to="/blog"
											className="text-sm font-medium text-gray-900 hover:text-gray-700"
										>
											Blog
										</Link> */}
										<Link
											to="/guaranteed-bike-tours"
											className="text-sm font-medium text-gray-900 hover:text-gray-700"
										>
											Guaranteed Trips
										</Link>
										<Link
											to="/about-us/reviews"
											className="text-sm font-medium text-gray-900 hover:text-gray-700"
										>
											Reviews
										</Link>
										{/* <Link
											to="/members-only"
											className="text-sm font-medium text-gray-900 hover:text-gray-700"
										>
											Membership
										</Link> */}
										{/* <Link
											to="/private"
											className="text-sm font-medium text-gray-900 hover:text-gray-700"
										>
											Private Trips
										</Link> */}
										{/* <Link
											to="/offers"
											className="text-sm font-medium text-gray-900 hover:text-gray-700"
										>
											Offers
										</Link> */}
										<Link
											to="/what-to-expect"
											className="text-sm font-medium text-gray-900 hover:text-gray-700"
										>
											What to Expect
										</Link>
										{/* <a
											href="https://www.trustpilot.com/review/artofbicycletrips.com"
											target="_blank"
											className="text-sm font-medium text-gray-900 hover:text-gray-700"
										>
											Reviews
										</a> */}
										{/* <Link
											to="/blog"
											className="text-sm font-medium text-gray-900 hover:text-gray-700"
										>
											Blog
										</Link> */}

										<Link
											to="/about-us/our-company"
											className="text-sm font-medium text-gray-900 hover:text-gray-700"
										>
											About Us
										</Link>
										{/* {resources.map((item) => (
											<Link
												key={item.name}
												to={item.to}
												className="text-sm font-medium text-gray-900 hover:text-gray-700"
											>
												{item.name}
											</Link>
										))} */}
									</div>
									{/* <div>
										<Link
											to="/contact-us"
											className="w-full flex items-center justify-center mb-4 px-4 py-2 border border-transparent rounded-md shadow-sm text-base font-medium text-white bg-primary hover:bg-primary"
										>
											Contact Us
										</Link>
										<Link
											to="/design-trip"
											className="w-full flex items-center justify-center px-4 py-2 border border-primary rounded-md shadow-sm text-base font-medium text-primary"
										>
											Design Trip
										</Link>
									</div> */}
								</div>
							</div>
						</Popover.Panel>
					</Transition>
				</>
			)}
		</Popover>
	);
}
